import { IConfigurarPagamentoColetaPrecoUseCase } from "../../../presentation/useCases/create/configurar_pagamento_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * ConfigurarPagamentoColetaPrecoUseCase
 */

export class ConfigurarPagamentoColetaPrecoUseCase implements IConfigurarPagamentoColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async configurarPagamentoColetaPreco(
    idColetaPreco: number,
    valorTotal: number,
    titulo: string | undefined,
    formaPagamento: string | undefined,
    notaFiscal: string | undefined,
    pagamentoAvista: number,
    dataPagamento: Date | undefined,
    pagamentoEm: number | undefined,
    entrada: number | undefined,
    valorEntrada: number | undefined,
    dataEntrada: Date | undefined,
    nroParcelas: number | undefined,
    dataPrimeiroPagamento: Date | undefined,
    nroDiasEntreParcelas: number | undefined,
    informacoesGerais: string | undefined,
  ): Promise<void> {
    await this.repository.configurarPagamentoColetaPreco(
      idColetaPreco,
      valorTotal,
      titulo ?? null,
      formaPagamento ?? null,
      notaFiscal ?? null,
      pagamentoAvista === 1,
      dataPagamento ?? null,
      pagamentoEm ?? null,
      entrada ?? null,
      valorEntrada ?? null,
      dataEntrada ?? null,
      nroParcelas ?? null,
      dataPrimeiroPagamento ?? null,
      nroDiasEntreParcelas ?? null,
      informacoesGerais ?? null,
    );
  }
}
